import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const WhiteSpacePreservedTypography = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word'
}));
